import { type ButtonHTMLAttributes, forwardRef } from "react"
import { Text } from "@/elements"
import Link from "next/link"

interface SignUpButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const SignUpButton = forwardRef<HTMLButtonElement, SignUpButtonProps>((props, ref) => {
  return (
    <Link href="/sign-up">
      <button
        {...props}
        className="group flex h-12 flex-col items-center overflow-hidden rounded-full bg-marketing-primary-light px-6 text-marketing-background-1-light shadow-[19px_6px_16px_0px_rgba(100,10,217,0.14),0px_4px_20px_0px_rgba(229,150,215,0.35)] dark:bg-marketing-primary-dark dark:text-marketing-background-1-dark"
        ref={ref}>
        <Text
          variant="CTASmall"
          className="marketing-transition-button-text flex h-12 shrink-0 items-center text-marketing-background-1-light group-hover:-translate-y-full group-hover:opacity-0 dark:text-marketing-background-1-dark">
          Sign up
        </Text>
        <Text
          variant="CTASmall"
          className="marketing-transition-button-text flex h-12 shrink-0 items-center text-marketing-background-1-light opacity-0 group-hover:-translate-y-full group-hover:opacity-100 dark:text-marketing-background-1-dark">
          Sign up
        </Text>
      </button>
    </Link>
  )
})

SignUpButton.displayName = "SignUpButton"
